"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BgLocalCopyComponentParameters = void 0;
exports.BgLocalCopyComponentParameters = [
    {
        id: 'source',
        label: 'Source Value',
        description: 'Text value to copy. Required when Target Value is set.',
        type: 'json',
        inputKind: 'text',
        paramType: 'ANY',
        required: false,
    },
    {
        id: 'source_file',
        label: 'Source File',
        description: 'File to copy. Required when Target File is set.',
        type: 'string',
        paramType: 'FILE',
        required: false,
    },
    {
        id: 'target',
        label: 'Target Value',
        description: 'Output key that receives the source value. Required when Source Value is set.',
        type: 'output',
        paramType: 'ANY',
        required: false,
    },
    {
        id: 'target_file',
        label: 'Target File',
        description: 'Output file key that receives the source file. Required when Source File is set.',
        type: 'output',
        paramType: 'FILE',
        required: false,
    },
];
//# sourceMappingURL=BgLocalCopyComponent.js.map